module.exports = __webpack_public_path__ + "static/media/appstore.b651e625.png";